"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _queryString = _interopRequireDefault(require("query-string"));

var _urlPattern = _interopRequireDefault(require("url-pattern"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Route Class
 */
var Route =
/*#__PURE__*/
function () {
  /**
   * @param {Object} params The route parameters.
   */
  function Route(params) {
    _classCallCheck(this, Route);

    var id = params.id,
        pathname = params.pathname,
        _params$pattern = params.pattern,
        pattern = _params$pattern === void 0 ? null : _params$pattern,
        _params$state = params.state,
        state = _params$state === void 0 ? {} : _params$state,
        _params$transform = params.transform,
        transform = _params$transform === void 0 ? null : _params$transform;

    var _pathname$split = pathname.split('#'),
        _pathname$split2 = _slicedToArray(_pathname$split, 2),
        path = _pathname$split2[0],
        _pathname$split2$ = _pathname$split2[1],
        hash = _pathname$split2$ === void 0 ? null : _pathname$split2$;

    var _queryString$parseUrl = _queryString["default"].parseUrl(path),
        query = _queryString$parseUrl.query,
        url = _queryString$parseUrl.url;

    var urlPattern = pattern ? new _urlPattern["default"](pattern) : null;
    this.id = id;
    this.pathname = url;
    this.pattern = pattern;
    this.location = pathname;
    this.params = urlPattern ? urlPattern.match(url) || {} : {};
    this.query = query;
    this.hash = hash;
    this.state = state;
    this.created = Date.now();
    this.updated = null;
    this.transform = transform;
    this.runTransform();
  }

  _createClass(Route, [{
    key: "runTransform",
    value: function runTransform() {
      if (typeof this.transform === 'function') {
        var transformed = this.transform(this);
        this.params = _objectSpread({}, this.params, {}, transformed.params);
        this.state = _objectSpread({}, this.state, {}, transformed.state);
      }
    }
    /**
     * @param {string} pattern The pattern to set for this route.
     * @param {Function} transform The transformer function.
     */

  }, {
    key: "setPattern",
    value: function setPattern(pattern, transform) {
      var urlPattern = new _urlPattern["default"](pattern);
      this.pattern = pattern;
      this.params = urlPattern.match(this.pathname) || {};
      this.transform = transform;
      this.runTransform();
    }
  }]);

  return Route;
}();

var _default = Route;
exports["default"] = _default;